import React from "react";
import "./AlertsFeedSkeleton.scss";

const AlertsFeedSkeleton = () => (
  <div className="alerts-feed-skeleton" aria-hidden="true">
    <div className="alerts-feed-skeleton__filter" />
    <div className="alerts-feed-skeleton__list">
      {[0, 1, 2].map((key) => (
        <div key={key} className="alerts-feed-skeleton__card">
          <div className="alerts-feed-skeleton__avatar" />
          <div className="alerts-feed-skeleton__body">
            <div className="alerts-feed-skeleton__line alerts-feed-skeleton__line--short" />
            <div className="alerts-feed-skeleton__line" />
            <div className="alerts-feed-skeleton__line" />
            <div className="alerts-feed-skeleton__line alerts-feed-skeleton__line--mid" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default AlertsFeedSkeleton;
